import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaIndustry,
    FaCheckCircle,
    FaVial,
    FaBoxOpen,
    FaClipboardCheck,
    FaSyncAlt
} from "react-icons/fa";

const processSteps = [
    {
        step: "01",
        icon: <FaIndustry />,
        title: "Advanced Production Facilities",
        text: "Modern infrastructure designed to ensure consistency, safety, and scalable production.",
    },
    {
        step: "02",
        icon: <FaVial />,
        title: "Raw Material Selection",
        text: "Carefully approved and high-quality raw materials sourced for effective formulations.",
    },
    {
        step: "03",
        icon: <FaCheckCircle />,
        title: "In-House Quality Evaluation",
        text: "Each batch undergoes strict testing for purity, performance, and safety standards.",
    },
    {
        step: "04",
        icon: <FaBoxOpen />,
        title: "Hygienic Packaging",
        text: "Automated and secure packaging systems preserve product integrity and shelf life.",
    },
    {
        step: "05",
        icon: <FaClipboardCheck />,
        title: "Regulatory Compliance",
        text: "All processes follow agricultural regulations and quality management guidelines.",
    },
    {
        step: "06",
        icon: <FaSyncAlt />,
        title: "Continuous Improvement",
        text: "Regular research, audits, and feedback help enhance product performance over time.",
    },
];

const ManufacturingProcess = () => {
    return (
        <section className="section manufacturing-section">
            <Container>

                {/* Common Heading */}
                <div className="section-title fade-up">
                    <h2>Manufacturing & Quality Process</h2>
                    <p>
                        From formulation to field delivery, every step is designed to ensure
                        safety, consistency, and farmer trust.
                    </p>
                </div>

                <Row>
                    {processSteps.map((item, index) => (
                        <Col lg={4} md={6} className="mb-4 fade-up" key={index}>
                            <div className={`process-card step-${item.step}`}>

                                <div className="process-header">
                                    <span className="step-number">{item.step}</span>
                                    <div className="process-icon">{item.icon}</div>
                                </div>

                                <h4>{item.title}</h4>
                                <p>{item.text}</p>

                            </div>
                        </Col>
                    ))}
                </Row>

            </Container>
        </section>
    );
};

export default ManufacturingProcess;
